module.exports = __webpack_public_path__ + "static/media/coupon01_en.007fa075.png";